import apiPrdNew from './apiPrdNew'

export const CommunicationService = {
  async findNotification(deliveryHash, event) {
    const res = await apiPrdNew.axiosInstance.get(
      `/communication?deliveryHash=${deliveryHash}&event=${event}`,
    )
    return res
  },
}
